module.exports = __webpack_public_path__ + "static/media/texspace.c53c8f25.png";